import { KeywordBase } from "@api/useGetKeywordBaseData";
import { useMemo } from "react";
import { TableColumn } from "@components/Table/TableColumns";
import TableCellSelectKeyword from "@vms/TableCells/TableCellSelect";
import { getRem, markMatch, Tooltip } from "@datassential/platform-ui-lib";
import Popup from "@components/Popup";
import { Link } from "react-router-dom";

import { getKeywordProfileLink } from "@core/routes";

export function useKeywordNameTableCell(
    data: Array<Pick<KeywordBase, 'id' | 'name' | 'description'>>,
    search: string,
) {
    return useMemo(
        (): TableColumn => ({
            key: 'name',
            head: "Item",
            headText: 'Keyword Name',
            Value: ({ index }) => {
                const keywordId = data[index].id ?? 0;
                const description = data[index]?.description ?? '';

                return (
                    <div
                        data-tooltip-id={`keyword-${keywordId}-name`}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                        }}
                    >
                        <TableCellSelectKeyword keywordId={keywordId}/>
                        <Link
                            to={getKeywordProfileLink(keywordId)}
                            style={{
                                color: "inherit",
                                textDecoration: 'none',
                            }}
                        >
                            <span dangerouslySetInnerHTML={{
                                __html: markMatch(data[index]?.name ?? '', search, true)
                            }}/>
                        </Link>
                        {!!description && (
                            <Popup>
                                <Tooltip
                                    id={`keyword-${keywordId}-name`}
                                    place="bottom-start"
                                    noArrow
                                    style={{
                                        width: getRem(300),
                                    }}
                                >
                                    {description}
                                </Tooltip>
                            </Popup>
                        )}
                    </div>
                )
            },
            valueText: (index) => data[index]?.name ?? '',
            style: {
                cell: {
                    paddingLeft: getRem(20),
                }
            }
        }),
        [data, search]
    );
}